import { DialogComponent, DialogOpenEvent, DialogCloseEvent } from '@theme/dialog';

/** @type {Map<string, boolean>} */
const openStateById = new Map();

/**
 * A custom element that manages a generic guide drawer.
 *
 * @extends {DialogComponent}
 */
class GuideDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();

    this.addEventListener(DialogOpenEvent.eventName, this.#handleDialogOpened);
    this.addEventListener(DialogCloseEvent.eventName, this.#handleDialogClosed);

    if (this.shouldStayOpen && !this.refs.dialog.open) {
      queueMicrotask(() => this.showDialog());
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.removeEventListener(DialogOpenEvent.eventName, this.#handleDialogOpened);
    this.removeEventListener(DialogCloseEvent.eventName, this.#handleDialogClosed);
  }

  updatedCallback() {
    super.updatedCallback();

    if (this.shouldStayOpen && !this.refs.dialog.open) {
      this.showDialog();
    }
  }

  open() {
    this.shouldStayOpen = true;
    this.showDialog();
  }

  close() {
    this.shouldStayOpen = false;
    this.closeDialog();
  }

  set shouldStayOpen(value) {
    if (!this.id) return;

    openStateById.set(this.id, value);
  }

  get shouldStayOpen() {
    if (!this.id) return false;

    return openStateById.get(this.id) ?? false;
  }

  #handleDialogOpened = () => {
    this.shouldStayOpen = true;
  };

  #handleDialogClosed = () => {
    this.shouldStayOpen = false;
  };
}

if (!customElements.get('guide-drawer-component')) {
  customElements.define('guide-drawer-component', GuideDrawerComponent);
}
